import { connect } from 'react-redux'
import {
  ICoordinatesWithShortKeyDTO,
  IGetGoogleMapPolyline,
  IMapBound,
  IMarker,
  IOSMDirectionReq,
  IStoreState
} from '../../types'
import { SET_DESTINATION_TO_TRIP_REQUEST, SET_ORIGIN_TO_TRIP_REQUEST } from '../../state/constants'
import { getOSMDirection, getDirections, actionCreators as mapActionCreators } from '../../state/actions/google_map'
import { selectPinLocation } from '../../state/actions/trips'
import StandardMapView from 'src/components/StandardMapView'

function mapStateToProps(state: IStoreState, ownProps: any) {
  const { isDraggable, renderStrategyStage: propsRenderStrategyStage } = ownProps

  const {
    mapView: { bounds, destination, origin, polygon, polyline, renderStrategyStage, zoom },
    trips: { currentTripId, currentTripState: tripState, items: tripItems }
  } = state

  const markers: IMarker[] = []

  if (ownProps.operatorLocation) {
    markers.push({
      type: 'car',
      lat: ownProps.operatorLocation.last_latitude,
      lng: ownProps.operatorLocation.last_longitude
    })
  }

  const mapData = {
    bounds,
    center: ownProps.center,
    currentTrip: tripItems[currentTripId],
    destination,
    isDraggable,
    markers,
    origin,
    polygon,
    polyline,
    renderStrategyStage: propsRenderStrategyStage || renderStrategyStage,
    tripState,
    zoom
  }

  return mapData
}

function mapDispatchToProps(dispatch: any) {
  return {
    getDirections: (dto: IGetGoogleMapPolyline) => dispatch(getDirections(dto)),
    selectPickup: (locationInfo: ICoordinatesWithShortKeyDTO) =>
      dispatch(selectPinLocation(locationInfo, SET_ORIGIN_TO_TRIP_REQUEST)),
    selectDropoff: (locationInfo: ICoordinatesWithShortKeyDTO) =>
      dispatch(selectPinLocation(locationInfo, SET_DESTINATION_TO_TRIP_REQUEST)),
    setPolyline: (routePolyline: string) => dispatch(mapActionCreators.setPolyline(routePolyline)),
    setBounds: (bounds: IMapBound) => dispatch(mapActionCreators.setBounds(bounds)),
    getOSMDirection: (dto: IOSMDirectionReq) => dispatch(getOSMDirection(dto))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StandardMapView)



// WEBPACK FOOTER //
// ./src/containers/googleMap/StandardGoogleMaps.ts